














































import { defineComponent, ref, computed } from '@vue/composition-api';
import Search from '../header/search/index.vue';
import NavToolBar from './navToolBar.vue';
import EasyNav from '@/components/quick-nav/easyNav.vue';
import { useBroadCastStream, useRouter } from '@/common/utils';
import { useLog } from '@/common/log';
import { useScrollActive } from '@/common/useScrollActive';
import { useHeaderUIConfig } from './util';
import { RouteName } from '@/router';


export default defineComponent({
    components: {
        Search,
        NavToolBar,
        EasyNav,
    },

    props: {
        feat: {
            type: String,
            default: 'defualt',
        },
        canSendShowLog: {
            type: Boolean,
            default: true,
        },
    },

    setup(props, { root }) {
        const isFixed = ref(false);
        const isDark = computed(() => {
            return props.feat === 'dark';
        });
        const isHeaderDark = computed(() => isFixed.value || isDark.value);
        const { headerStyle, logoStyle, easyNavUIData, searchUIData, navToolBarUIData, loginStyle, subListUIData } = useHeaderUIConfig(isHeaderDark);
        const { route } = useRouter();

        const log = useLog();
        if (!isDark.value) {
            useBroadCastStream('transFixed', (show: boolean) => {
                isFixed.value = show;
            });
        }

        function backHome() {
            // 如果是推荐页内点击logo回到首页的话需要新开tab
            if (route.value?.name === RouteName.NewReco) {
                window.open('/?isHome=1', '_blank');
            } else {
                root.$router.push('/');
            }
        }

        function goNext(obj: any) {
            log(obj);
            backHome();
        }
        useScrollActive('html');
        return {
            isFixed,
            isDark,
            headerStyle,
            logoStyle,
            easyNavUIData,
            searchUIData,
            navToolBarUIData,
            loginStyle,
            subListUIData,
            log,
            backHome,
            goNext,
        };
    },
});

